import $ from 'jquery';
import {util} from './util';
import {discounts} from './discounts';

export const FlowViewManager = {
  init() {
    const self = this;
    this.$views = $('.flow-view');
    this.$navSteps = $('.flow-nav');
    this.$body = $('.body');
    this.flows = {
      plansV2: [
                ['availability', 'availability'],
                ['plan-selector-v2', 'select box'],
                ['meal-menu', 'add items'],
                ['order-confirmation', 'review order'],
      ],
      oneTimeToSubscription: [
                ['plan-selector-v2', 'select box'],
                ['meal-menu', 'add items'],
                ['order-confirmation', 'review order'],
      ],
    };
    this.state = {
      previousStep: 1,
    };
    const {step, flow} = util.getUrlVars();

    if (flow == 'oneTimeToSubscription') {
      this.state.step = 1;
      this.state.flow = 'oneTimeToSubscription';
    } else {
      this.state.step = 2;
      this.state.flow = 'plansV2';
    }

    if (step) {
      this.state.step = step;
    }

        // Set initial state
    this.setInitialState();

    document.onmouseover = function() {
            // User's mouse is inside the page.
      window.innerDocClick = true;
    };

    document.onmouseleave = function() {
            // User's mouse has left the page.
      window.innerDocClick = false;
    };

    window.addEventListener('popstate', () => {
      self.refreshNavSteps();
      self.nextStep(self.state.flow, self.state.previousStep);
    });
  },

  setInitialState() {
    /* eslint-disable camelcase */
    if (window.location.href.indexOf('meal-editor') !== -1) {
      return;
    }
    const vars = util.getUrlVars();
    const {
      flow,
      user_segmentation,
      frequency_editable,
      auto_add_meals,
      prepopulated_meals,
      skip_meal_selection,
      skip_meal_selector,
      checkoutCreated,
    } = vars;

    if (user_segmentation) {
      this.state.user_segmentation = user_segmentation;
    } else {
      this.state.user_segmentation = 'custom';
    }

    // Note: There is a script in the `src/layout/theme.liquid` html head that validates zip_code and email params.
    this.refreshNavSteps(flow);
    this.nextStep(this.state.flow, this.state.step);

    // Skips to Meal Menu
    if (this.state.flow === 'custom') {

      this.state.step = 2;
      this.nextStep(this.state.flow, this.state.step);
    }
    // Skips to Order Confirmation if Single
    if (
        (
            (auto_add_meals || prepopulated_meals) &&
            (skip_meal_selection === 'true' || skip_meal_selector === 'true')
        ) || checkoutCreated === 'true'
    ) {
      this.state.step = this.flows[this.state.flow].findIndex((i) => i[0] === 'order-confirmation') + 1;
      this.nextStep(this.state.flow, this.state.step);
    }

    // Hide Frequency Selector
    if (frequency_editable === 'false') {
      $('#frequency-confirmation-select').hide();
      $('#frequency-confirmation').show();
    }
    /* eslint-enable camelcase */
  },

  getNext() {
    for (let i = 0; i < this.$views.length; i++) {
      if ([...this.$views[i].classList].includes('flow-view-active')) {
        return this.$views[i + 1].className.split(/\s+/)
          .find((c) => c.includes('step-'))
          .replace('step-', '');
      }
    }
  },

  nextStep(flow, step, callback) {
    const previousStep = Number(this.$navSteps.filter('.current').attr('data-step')) || 1;
    this.state.previousStep = previousStep;
    if (typeof step === 'string') {
      step = step.replace(/\D/g, '');
    }
    step = Number(step);
    this.state.step = step;
    this.state.flow = flow;
    const [viewId, viewName] = this.flows[flow][step - 1];

    if (viewName === 'availability') {
      util.getErrorLogger().error(
        'Redirecting user to Check Availability Page',
        {
          url: window.location.href,
          flow,
          step,
          previousStep,
          viewId,
        },
      );
      window.location.href = `/pages/check-availability${window.location.search}`;
    }

    this.$views.removeClass('flow-view-active').closest('.shopify-section').hide();
    this.$navSteps.removeClass('flow-nav-active current complete');

    const $step = this.$views.filter(`.step-${viewId}`);
    $step.addClass('flow-view-active').closest('.shopify-section').show();

    Array.from(Array(step), (_, i) => {
      i + 1 < step ? this.$navSteps.filter(`.flow-nav-step-${i + 1}`).addClass('complete') : false;
    });

    this.$navSteps.closest(`.flow-nav-step-${viewId}`).addClass('flow-nav-active current');
    if (previousStep !== step) {
      this.scrollToTop();

            // Dispatch event with section id
      const stepEvent = new CustomEvent(`step:${$step.attr('id')}`);
            // Defers execution and allows other sections to load and add event listeners.
      setTimeout(() => {
        document.dispatchEvent(stepEvent);
      }, 0);
    }

    if (step === 1) {
            // hide nav steps on step 1
      this.$navSteps.hide();
    } else {
      this.$navSteps.show();
    }

    if (callback) {
      callback();
      return false;
    }
  },

  previousStep(callback) {
    const step = this.$navSteps.filter('.current').attr('data-step');
    const lastStep = step > 2 ? step - 1 : 1;
    this.nextStep(lastStep, () => {
      util.insertUrlParam('step', `${lastStep}`);
    });
    if (callback) {
      callback();
      return false;
    }
  },

  refreshNavSteps(flowOverride) {
    const flow = flowOverride || this.state.flow;
    const $navStepsWrapper = $('#subscription-flow ul');
    $navStepsWrapper.html('');
    const {frequency, checkout, box_editable} = util.getUrlVars();

    this.flows[flow].forEach((view, i) => {
      const [viewId, viewName] = view;
      const step = i + 1;
      const li = document.createElement('li');
      const href = viewName === 'availability' ? '/pages/check-availability' : '#';
      li.dataset.step = step;
      li.classList.add('flow-nav', `flow-nav-step-${step}`, `flow-nav-step-${viewId}`);
      li.innerHTML = `<a href="${href}" aria-labelledby="nav-text-${viewId}"><span class="nav-text" id="nav-text-${viewId}">${viewName}</span></a>`;
      if ((frequency === '0' && view[1] === 'frequency' || box_editable === 'false')) {
                // hide steps
      } else {
        $navStepsWrapper.append(li);
      }
    });

        // Handle Banner Visibility
    discounts.hideBanner(checkout === 'shopify' && frequency === '0');

    this.$navSteps = $('.flow-nav');
  },

  scrollToTop() {
    $('html, body').animate({scrollTop: 0}, 'slow');
  },
};
